import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { Box, Button, Grid, Paper, Stack, TextField, Typography } from "@mui/material";
import EmployerSidebar from "../components/Employer/EmployerSidebar";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import applicant from '../images/profilePhoto.png';
import { ArrowForwardIos, Facebook, Instagram, LinkedIn, Twitter, WhatsApp } from "@mui/icons-material";
import InputStyle from "../assets/InputStyle";
import VideocamIcon from '@mui/icons-material/Videocam';
import PhoneIcon from '@mui/icons-material/Phone';
import ProfileCard from "../components/Profile/ProfileCard";
import SimiliarCandidateCard from "../components/Employer/SimiliarCandidateCard";
import Layout from "../assets/Layout";
import UserLayout from "../assets/UserLayout";
import Appplicants from "./Appplicants";

const ApplicantsPreview = () => {
    const { user } = useSelector((state) => ({ ...state }));
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");
    const [template, setTemplate] = useState("");
    const [message, setMessage] = useState("");
    const [range, setRange] = useState("");
    const [location, setLocation] = useState("");
    const [experiance, setExperiance] = useState("");
    const [dateApplied, setDateApplied] = useState("");
    const [search, setSearch] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
        if (!localStorage.getItem("user")) {
            navigate('/')
        }
    }, [])

    const handleSearch = (event) => {
        const searchTerm = event.target.value;
    };
    return (
        <>
            <Layout>
                <UserLayout>
                    <Box mt={8} px={{md:5, xs:1}}>
                        <Grid container>
                            <Grid item xs={12} md={6}>
                                <Typography className="heading1bold">
                                    Applicants
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    sx={{ background: '#3665D014', width: '70%', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)', }} // Updated style
                                    variant="outlined"
                                    size="small"
                                    placeholder="Search"
                                    InputProps={{
                                        endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                                    }}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </Grid>
                        </Grid>
                        {/* <Grid container mt={5}>
                            <Grid item md={2} xs={6}>
                                <select onChange={(e) => setRange(e.target.value)} style={{ borderRadius: '10px', padding: '10px 12px', background: '#D9E3F6', border: 'none', color: '#888' }}>
                                    <option>
                                        Salary Range
                                    </option>
                                    <option>1 lakh</option>
                                    <option>2 lakh</option>
                                    <option>5 lakh</option>
                                </select>
                            </Grid>
                            <Grid item md={1}></Grid>
                            <Grid item md={2} xs={6}>
                                <select onChange={(e) => setLocation(e.target.value)} style={{ borderRadius: '10px', padding: '10px 12px', background: '#D9E3F6', border: 'none', color: '#888' }}>
                                    <option>
                                        Location
                                    </option>
                                    <option>1 lakh</option>
                                    <option>2 lakh</option>
                                    <option>5 lakh</option>
                                </select>
                            </Grid>
                            <Grid item md={1}></Grid>
                            <Grid item md={2} xs={6}>
                                <select onChange={(e) => setExperiance(e.target.value)} style={{ borderRadius: '10px', padding: '10px 12px', background: '#D9E3F6', border: 'none', color: '#888' }}>
                                    <option>
                                        Experience Level
                                    </option>
                                    <option>1 lakh</option>
                                    <option>2 lakh</option>
                                    <option>5 lakh</option>
                                </select>
                            </Grid>
                            <Grid item md={1}></Grid>
                            <Grid item md={2} xs={6}>
                                <select onChange={(e) => setDateApplied(e.target.value)} style={{ borderRadius: '10px', padding: '10px 12px', background: '#D9E3F6', border: 'none', color: '#888' }}>
                                    <option>
                                        Date Applied
                                    </option>
                                    <option>1 lakh</option>
                                    <option>2 lakh</option>
                                    <option>5 lakh</option>
                                </select>
                            </Grid>
                        </Grid> */}

                        <Box sx={{ }}>
                            <Appplicants style={{ marginTop: '10px' }} />
                        </Box>

                        {/* <Grid container mt={5} spacing={4}>
                            <Grid item md={3} sx={{ height: '60vh', overflowY: 'scroll' }} className="customScrollbar">
                                <Typography sx={{ textAlign: 'center', height: '7rem', paddingTop: '2.5rem', border: '1px solid #e2e2e2' }} className="subHeading1Bold applicantHead">20 Applicants</Typography>
                                {
                                    [...Array(20)].map((item, index) => (
                                        <Typography key={index} sx={index === 0 ? { height: '7rem', paddingTop: '1.5rem', borderTop: '1px solid #E2E2E2', marginTop: '3.8rem' } : { height: '7rem', paddingTop: '1.5rem', borderTop: '1px solid #E2E2E2' }} className="subHeading1Bold">
                                            <Box sx={{ cursor: 'pointer' }}>
                                                <span sx={{ marginLeft: '2rem' }} className="subHeading2Bold">
                                                    Anuj Sharma
                                                </span>
                                                <span sx={{ marginLeft: '2rem' }} className="text1Mid">
                                                    UI-UX Designer
                                                </span>
                                                <span sx={{ marginLeft: '2rem' }} className="text1Mid">
                                                    Sector 44, Gurugram
                                                </span>
                                            </Box>
                                        </Typography>
                                    ))
                                }
                            </Grid>
                            <Grid item md={9}>
                                <Paper sx={{ borderRadius: '20px' }}>
                                    <Box sx={{ padding: '1rem' }}>
                                        <Grid container>
                                            <Grid item md={6}>
                                                <Typography sx={{ border: '1px solid #E2E2E2', padding: '1rem', borderRadius: '20px' }}>
                                                    <AccessTimeIcon sx={{ marginRight: '1rem' }} />
                                                    <span className="text1Bold">Application expiring in 11 days </span>
                                                </Typography>
                                            </Grid>
                                            <Grid item md={6} xs={12}>
                                                <Box sx={{ marginLeft: '25%', display: 'flex' }}>
                                                    <span style={{ padding: '1rem' }}>Status: </span>
                                                    <select style={{ border: '1px solid #D2D2D2', borderRadius: '11px', padding: '0.8rem', width: '90%' }}>
                                                        <option value={""}>Select</option>
                                                        <option value={"Pending"}>Pending</option>
                                                        <option value={"Completed"}>Completed</option>
                                                    </select>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2} mt={2}>
                                            <Grid item xs={5} md={4}>
                                                <img src={applicant} alt="applicant" className="applicantImg" />
                                            </Grid>
                                            <Grid item xs={6} md={3}>
                                                <Typography className="subHeading1Bold">Anuj Sharma</Typography>
                                                <Typography className="text1Mid" sx={{ lineHeight: '2rem' }}>UI - UX Designer | 23 Year Old</Typography>
                                                <Typography className="text1Mid" sx={{ lineHeight: '2rem' }}>Sector 44,Gurgram</Typography>
                                                <Typography className="text1Mid" sx={{ color: '#2544EE', lineHeight: '2rem' }}>AnujSharma@gmail.com</Typography>
                                            </Grid>
                                            <Grid item md={2}></Grid>
                                            <Grid item xs={12} md={3}>
                                                <Button variant="outlined" sx={{ borderRadius: '50px', width: '100%' }}>Share Resume <ArrowForwardIos sx={{ fontSize: '14px', ml: 1 }} /></Button>
                                                <Button variant="contained" sx={{ backgroundColor: '#2544EE', borderRadius: '50px', mt: 5, width: '100%' }}>Download Resume <ArrowForwardIos sx={{ fontSize: '14px', ml: 1 }} /></Button>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2} mt={3} >
                                            <Box sx={{ padding: '1rem', width: '100%' }}>
                                                <Typography className="subHeading2Bold" sx={{ color: '#2544EE', borderBottom: '2px solid #E2E2E2' }}>Application</Typography>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} md={8}>
                                                        <Typography className="text1Bold" sx={{ paddingTop: '1rem' }}>Job Description</Typography>
                                                        <Typography textAlign={"justify"}>
                                                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                                            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                                            when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                                            It has survived not only five centuries, but also the leap into electronic typesetting,
                                                            remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets
                                                            containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker
                                                            including versions of Lorem Ipsum.
                                                        </Typography>
                                                        <Typography className="text1Bold" sx={{ paddingTop: '1rem' }}>Responsibilities</Typography>
                                                        <Typography textAlign={"justify"}>
                                                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                                            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                                            when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                                            It has survived not only five centuries, but also the leap into electronic typesetting,
                                                            remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets
                                                            containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker
                                                            including versions of Lorem Ipsum.
                                                        </Typography>
                                                        <Typography className="subHeading2Bold" sx={{ mt: 2 }}>
                                                            Salary - <span style={{ color: '#2544EE' }}>4,00,000 to 5,00,000</span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <Paper>
                                                            <Stack sx={{ padding: '1rem' }} spacing={2}>
                                                                <Typography className="subHeading2Bold">Notify Candidate</Typography>
                                                                <Box>
                                                                    <InputStyle name={"Name"}>
                                                                        <input placeholder="Name" onChange={(e) => setName(e.target.value)} />
                                                                    </InputStyle>
                                                                </Box>
                                                                <Box>
                                                                    <InputStyle name={"Email"}>
                                                                        <input placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
                                                                    </InputStyle>
                                                                </Box>
                                                                <Box>
                                                                    <InputStyle name={"Phone Number"}>
                                                                        <input placeholder="Phone Number" onChange={(e) => setNumber(e.target.value)} />
                                                                    </InputStyle>
                                                                </Box>
                                                                <Box>
                                                                    <InputStyle name={"Select mail Templates"}>
                                                                        <select
                                                                            onChange={(e) => setTemplate(e.target.value)}
                                                                            className="profile-skills-box">
                                                                            <option value={"Template 1"}>Template 1</option>
                                                                            <option value={"Template 2"}>Template 2</option>
                                                                            <option value={"Template 3"}>Template 3</option>
                                                                        </select>
                                                                    </InputStyle>
                                                                </Box>
                                                                <Box>
                                                                    <textarea
                                                                        placeholder="Write your message"
                                                                        style={{ resize: 'none', width: '100%', border: '1px solid #E2E2E2', borderRadius: '11px' }}
                                                                        rows={3}
                                                                        onChange={(e) => setMessage(e.target.value)}
                                                                    />
                                                                </Box>
                                                                <Button variant="contained" sx={{ borderRadius: '11px', backgroundColor: '#2544EE' }}>
                                                                    Submit Now <ArrowForwardIos sx={{ fontSize: '14px' }} />
                                                                </Button>
                                                            </Stack>
                                                        </Paper>
                                                        <Typography className="text1Bold" sx={{ marginTop: '1rem', marginBottom: '1rem' }}>Connect with Candidate</Typography>
                                                        <Grid container spacing={4} >
                                                            <Grid item md={4}>
                                                                <WhatsApp sx={{ backgroundColor: '#2544EE', color: '#FFF', borderRadius: '50%', fontSize: '2rem', width: '3rem', height: '3rem', padding: '0.5rem' }} />
                                                            </Grid>
                                                            <Grid item md={4}>
                                                                <VideocamIcon sx={{ backgroundColor: '#2544EE', color: '#FFF', borderRadius: '50%', fontSize: '2rem', width: '3rem', height: '3rem', padding: '0.5rem' }} />
                                                            </Grid>
                                                            <Grid item md={4}>
                                                                <PhoneIcon sx={{ backgroundColor: '#2544EE', color: '#FFF', borderRadius: '50%', fontSize: '2rem', width: '3rem', height: '3rem', padding: '0.5rem' }} />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container mt={2}>
                                                            <Grid item md={12}>
                                                                <Button variant="contained" sx={{ backgroundColor: '#2544EE', borderRadius: '50px', mt: 2, width: '100%' }}>Interview Now! <ArrowForwardIos sx={{ fontSize: '14px', ml: 1 }} /></Button>
                                                                <Button variant="outlined" sx={{ borderRadius: '50px', width: '100%', mt: 2 }}>Schedule Interview <ArrowForwardIos sx={{ fontSize: '14px', ml: 1 }} /></Button>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container spacing={4} mt={2}>
                                                            <Grid item md={3}>
                                                                <Facebook sx={{ backgroundColor: '#2544EE', color: '#FFF', borderRadius: '50%', fontSize: '2rem', width: '3rem', height: '3rem', padding: '0.5rem' }} />
                                                            </Grid>
                                                            <Grid item md={3}>
                                                                <Twitter sx={{ backgroundColor: '#2544EE', color: '#FFF', borderRadius: '50%', fontSize: '2rem', width: '3rem', height: '3rem', padding: '0.5rem' }} />
                                                            </Grid>
                                                            <Grid item md={3}>
                                                                <LinkedIn sx={{ backgroundColor: '#2544EE', color: '#FFF', borderRadius: '50%', fontSize: '2rem', width: '3rem', height: '3rem', padding: '0.5rem' }} />
                                                            </Grid>
                                                            <Grid item md={3}>
                                                                <Instagram sx={{ backgroundColor: '#2544EE', color: '#FFF', borderRadius: '50%', fontSize: '2rem', width: '3rem', height: '3rem', padding: '0.5rem' }} />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Grid>
                                    </Box>
                                </Paper>
                                <Grid container spacing={2} mt={2}>
                                    <Grid item md={12}>
                                        <Typography className="subHeading1Bold">Similar Candidates</Typography>
                                    </Grid>
                                    <Grid item md={12}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6} md={4} mt={10}>
                                                <SimiliarCandidateCard />
                                            </Grid>
                                            <Grid item xs={6} md={4} mt={10}>
                                                <SimiliarCandidateCard />
                                            </Grid>
                                            <Grid item xs={6} md={4} mt={10}>
                                                <SimiliarCandidateCard />
                                            </Grid>
                                            <Grid item xs={6} md={4} mt={10}>
                                                <SimiliarCandidateCard />
                                            </Grid>
                                            <Grid item xs={6} md={4} mt={10}>
                                                <SimiliarCandidateCard />
                                            </Grid>
                                            <Grid item xs={6} md={4} mt={10}>
                                                <SimiliarCandidateCard />
                                            </Grid>
                                            <Grid item xs={6} md={4} mt={10}>
                                                <SimiliarCandidateCard />
                                            </Grid>
                                            <Grid item xs={6} md={4} mt={10}>
                                                <SimiliarCandidateCard />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid> */}
                    </Box>
                </UserLayout>
            </Layout>
        </>
    )
}

export default ApplicantsPreview;